import script from "./TeamEditDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamEditDrawer.vue?vue&type=script&setup=true&lang=js"

import "./TeamEditDrawer.vue?vue&type=style&index=0&id=0356a52f&lang=scss"

const __exports__ = script;

export default __exports__